import BaseService from './services/BaseService';
import GoodsService from './services/GoodsService';
import StoreService from "./services/StoreService";
import RecommendSearchingListService from "./services/RecommendSearchingListService";

class Service {
  constructor() {
    this.base = new BaseService();
    this.goods = new GoodsService();
    this.store = new StoreService();
    this.searching = new RecommendSearchingListService();
  }
}

const services = {
  install(Vue, name = '$service') {
    Object.defineProperty(
      Vue.prototype,
      name,
      { value: new Service() },
    );
  },
};

export default services;



// WEBPACK FOOTER //
// ./src/service/Service.js